export function raise<A = never>(error: unknown): A {
  throw error;
}
